import React from 'react';
import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope, FaHeart } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <FooterContainer>
      <GradientLine />
      <FooterInner>
        <SocialRow>
          <SocialLink href="https://github.com/HimanshuRawat143" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
          </SocialLink>
          <SocialLink href="https://www.linkedin.com/in/himanshurawat12" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </SocialLink>
          <SocialLink href="https://x.com/HimanshuR3127" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <FaTwitter />
          </SocialLink>
          <SocialLink href="mailto:himu35311@gmail.com" aria-label="Email">
            <FaEnvelope />
          </SocialLink>
        </SocialRow>

        <BuiltBy>
          Designed & Built by <span>Himanshu Rawat</span>
        </BuiltBy>

        <Copyright>
          © {currentYear} — Made with <FaHeart className="heart" /> & lots of ☕
        </Copyright>

        <BackToTop onClick={scrollToTop}>↑ Back to top</BackToTop>
      </FooterInner>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  position: relative;
  padding-bottom: 3rem;
`;

const GradientLine = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    ${props => props.theme.colors.primary},
    ${props => props.theme.colors.accent},
    transparent
  );
  opacity: 0.3;
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

const SocialRow = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  color: ${props => props.theme.colors.textSecondary};
  font-size: 1.1rem;
  transition: all 0.3s ease;

  &:hover {
    color: ${props => props.theme.colors.primary};
    border-color: ${props => props.theme.colors.primary};
    background: rgba(99, 102, 241, 0.08);
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(99, 102, 241, 0.15);
  }
`;

const BuiltBy = styled.p`
  font-size: 0.85rem;
  color: ${props => props.theme.colors.textMuted};
  font-family: ${props => props.theme.fonts.mono};
  
  span {
    color: ${props => props.theme.colors.primary};
  }
`;

const Copyright = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.textMuted};
  display: flex;
  align-items: center;
  gap: 0.3rem;

  .heart {
    color: ${props => props.theme.colors.secondary};
    font-size: 0.7rem;
  }
`;

const BackToTop = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.colors.textMuted};
  font-size: 0.75rem;
  font-family: ${props => props.theme.fonts.mono};
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  
  &:hover {
    color: ${props => props.theme.colors.primary};
    background: rgba(99, 102, 241, 0.05);
  }
`;

export default Footer;